export const UpArrow = (props) => {
  const svgStyle = {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
  };
  return (
    <svg
      {...props}
      style={svgStyle}
      xmlns="http://www.w3.org/2000/svg"
      width="14.561"
      height="14"
      viewBox="0 0 14.561 14"
    >
      <path
        d="m0 0 6 6-6 6"
        transform="rotate(-90 5.5 4)"
        data-name="Group 9658"
      />
    </svg>
  );
};
